import { Model, Factory } from 'miragejs'

import type { SchemaAttributes } from '../types.js'
import type { MockServer } from './server.js'

export type ImportFileData = SchemaAttributes<'ImportFile'>

export const model = Model
export const factory = Factory.extend<ImportFileData>({})

export function routes(server: MockServer) {
  // Handle POST requests to /import/upload
  server.post('/import/upload', () => {
    return new Response()
  })
}
